import { useEffect } from 'react';
import useAuthenticationState from './useAuthentication';
import { useUserGetMe } from 'api/user/user';

const useMe = () => {
  const {
    state: { userId, isAuthenticated },
    signout,
  } = useAuthenticationState();
  // const users = useUsers();

  const getMeCall = useUserGetMe({
    query: {
      enabled: isAuthenticated && userId !== undefined,
      staleTime: 5 * 60 * 1000,
    },
  });

  // Sign out if user is not active
  useEffect(() => {
    if (getMeCall.data && !getMeCall.data.isActive) {
      signout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getMeCall.data]);

  return getMeCall.data ?? null;
};

export default useMe;
